interface WrapperCharacters {
    prefix: string;
    suffix: string;
}
const allowedWrappers: WrapperCharacters[] = [
    { prefix: '{{', suffix: '}}' },
    { prefix: '*|', suffix: '|*' },
    { prefix: '[', suffix: ']' },
    { prefix: '[[', suffix: ']]' },
    { prefix: '%', suffix: '%' },
    { prefix: '{{ ', suffix: ' }}' },
    { prefix: '$', suffix: '' },
    { prefix: '{$', suffix: '}' },
];
export const coreAllowedCharacters = /[a-zA-Z0-9_.]+/;

const wrapperRegexParts = allowedWrappers.map(({ prefix, suffix }) => {
    // Escape special regex characters in the prefix and suffix
    const regexCleaner = /[.*+?^${}()|[\]\\]/g;
    const escapedPrefix = prefix.replace(regexCleaner, '\\$&');
    const escapedSuffix = suffix.replace(regexCleaner, '\\$&');

    // Return a regex part that matches a string wrapped with the prefix and suffix
    return `^${escapedPrefix}(${coreAllowedCharacters.source})${escapedSuffix}$`;
});

const allowedCharacters = new RegExp(`^${coreAllowedCharacters.source}$|${wrapperRegexParts.join('|')}`);

export const isValidScriptField = (field: string) => {
    return allowedCharacters.test(field);
};

export const cleanScriptField = (field: string) => {
    const match = allowedCharacters.exec(field);
    if (!match) {
        return '';
    }

    // A match array will have the full match as the first element, followed by the capturing groups
    // The first capturing group that is not empty is the clean field
    const cleanField = match.slice(1).find(Boolean);

    return cleanField || match[0];
};

export const isContainSpaces = (field: string) => {
    return field.includes(' ');
};
